import background1 from "../assets/backgrounds/membership/background-1.svg";
import background2 from "../assets/backgrounds/membership/background-4.svg";
import background3 from "../assets/backgrounds/membership/background-5.svg";

export const getRandomBg = () => {
  const backgrounds = [background1, background2, background3];
  return backgrounds[Math.floor(Math.random() * backgrounds.length)];
};
